import axios from "axios";
import type {IOwayoDataModel} from "../model";
import {EventListener, EventVerteiler} from "@k/global/eventVerteiler";
import {createGUID} from "@k/global/globalUtils";
import {ChromoLogo, Logo, StockLogo} from "../selectableObjects";
import globalsObject, {handleError} from "../globalsObject";
import type {FileUploadResponse} from "../interfaceDataClasses";
import {LogoTargetAfterChoosing, RahmentabsLogoReiter} from "../rahmentabsModules/rahmenTabsLogoReiter";
import {sendPostRequest} from "@k/global/axiosFormWrapper";
import {SelObTypes} from "../SelObTypes";
import {LogoPoolEntry} from "../databaseInterfaceClasses";
export class LogoPoolController extends EventListener{
    public model: IOwayoDataModel;
    private uploadedLogosThisSessionCounter = 0;

    public constructor(model:IOwayoDataModel) {
        super();
        this.model = model;
        this.initEventListeners();
    }

    private initEventListeners() {
        const $this = this;
        this
            .addEventListener("sendLogoForConversionEvent", function(data) {
                $this.sendLogoForConversion(data.file, data.name, data.email, data.comment);
            })

            .addEventListener("logoPoolChangedEvent", ()=>this.testIfLogoPoolIsUpToDate())
            .addEventListener("unsupportedButConvertableLogoFormatInUploadEvent", (file)=>this.unsupportedButConvertableLogoFormatInUpload(file))
            .addEventListener("testIfLogoPoolIsUpToDateEvent", ()=>this.testIfLogoPoolIsUpToDate());
    }

    public logoUploaded(ajaxResponse:FileUploadResponse) {
        if (ajaxResponse.success === false) {
            handleError("ajaxFail", "fileUpload", ajaxResponse.error);
            return;
        }
        this.uploadedLogosThisSessionCounter++;
        if (this.model.user.isLoggedIn() === false) {
            EventVerteiler.broadcast("displayNotLoggedInWarningEvent");
        }
        this.testIfLogoPoolIsUpToDate();
        EventVerteiler.broadcast("newLogoUploadedEvent", ajaxResponse);
        if(RahmentabsLogoReiter.logoTargetAfterChoosing === LogoTargetAfterChoosing.DRAFT) {
            globalsObject.resourceManager.createTask("insertLogo"+ajaxResponse.id).discardAfterExecution().when("logoPool", "loaded").thenDo(
                ()=>EventVerteiler.broadcast("directlyCreateLogoEvent", {type:SelObTypes.LOGO, id: ajaxResponse.id})
            )
        }
    }

    private testIfLogoPoolIsUpToDate() {
        const $this = this;
        LogoPoolController.invalidateLogoPoolResource();
        sendPostRequest("/konfigurator_php/designmodul/logos.php", {}).then(
            (response)=>{
                const loadedLogoPool = response.data.map(l=>{
                    l.id = parseInt(l.id, 10);
                    return l;
                });
                const newLogos = $this.model.logoPool.getAddedLogos(loadedLogoPool);
                const deletedLogos = $this.model.logoPool.getDeletedLogos(loadedLogoPool);

                if (deletedLogos.length > 0) {
                    $this.model.logoPool.removeLogosFromLogoPool(deletedLogos);
                    // EventVerteiler.broadcast("logoPoolItemsDeletedEvent", {deletedLogos: deletedLogos});
                }
                if (newLogos.length > 0) {
                    $this.model.logoPool.addLogos(newLogos);
                    // EventVerteiler.broadcast("logoPoolItemsRemotelyAddedEvent", {newLogos:newLogos});
                }
                EventVerteiler.broadcast("initLogoPoolEvent", {logos:loadedLogoPool});
                EventVerteiler.broadcast("logopoolUpToDateEvent");
                LogoPoolController.registerLogoPoolResource();
            });
    }


    private static invalidateLogoPoolResource = ()=>globalsObject.resourceManager.executeInvalidation("LogoPoolReload");
    private static registerLogoPoolResource = ()=>globalsObject.resourceManager.registerLoadedResourceWithoutData("logoPool", "LogoPoolReload");


    public getLogoPoolEntryByTypeAndFilename(type, filename) {
        return this.model.logoPool.getLogoByTypeAndFilename(type, filename);
    }

    public getUsername = ()=>this.model.user.getUserName();

    public unsupportedButConvertableLogoFormatInUpload(file:File) {
        if (!this.model.user.isLoggedIn()) {
            EventVerteiler.broadcast("loginNeededForLogoConversionEvent");
            return;
        }
        if (!this.model.user.getEmail()) {
            EventVerteiler.broadcast("logoConversionRequestedWithoutEmailEvent", {file:file});
            return;
        }
        EventVerteiler.broadcast("logoConversionRequestedEvent", {file:file});
    }


    private sendLogoForConversion(file:File, name:string, email = "", comment = "") {

        if (this.model.user.getEmail() === "") {
            this.model.user.setEmail(email);
        }

        if (email === "") {
            email = this.model.user.getEmail() ? this.model.user.getEmail() : "";
        }
        EventVerteiler.broadcastBlockRequest('fileUpload');
        const formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('login', this.model.user.getUserName());
        formData.append('email', email);
        formData.append('language', this.model.getSprache());
        formData.append('land', this.model.getLand());
        formData.append('sport', this.model.getWebsportFuerProduktAuswahlNormalized());
        formData.append('comment', comment);
        formData.append("name", name)
        axios({
            url:"/konfigurator_php/designmodul/fileupload/sendFileToOwayo.php",
            method:"post",
            data:formData,
            responseType:"text"
        }).then(response=>{
            EventVerteiler.broadcastBlockRequestEnded('fileUpload');
            if (response.data === "success") {
                EventVerteiler.broadcast(email ? "displayLogoConversionMailSentDialogEvent" : "displayLogoConversionMailSentNoEmailDialogEvent");
            } else {
                EventVerteiler.broadcast("displayLogoConversionMailErrorHappenedEvent")
            }
            EventVerteiler.broadcast("resetFileUploadEvent");
        })
    }

    public static createLogoObjectStatic(logoPoolEntry:LogoPoolEntry):Logo|ChromoLogo {
        let logoObject;

        const part="";
        const id = createGUID();

        switch(logoPoolEntry.type) {
            case SelObTypes.LOGO:
                logoObject = new Logo({
                    id          : id,
                    partName    : part,
                    filename  : logoPoolEntry.filename,
                    pathToLogo  : logoPoolEntry.logoURL,
                    logoId      : logoPoolEntry.id,
                    isAILogo:logoPoolEntry.isAILogo,
                    hasTackleTwill :false,
                    berechnungsFeature : "",
                    zuLoeschenBeiProduktUndDesignWechsel:0
                });
                break;
            case SelObTypes.CHROMOLOGO:
                logoObject = new ChromoLogo({
                    id          : id,
                    partName    : part,
                    filename  : logoPoolEntry.filename.replace(/\.png$/, ".svg"),
                    pathToLogo  : logoPoolEntry.logoURL,
                    logoId      : null,
                    chromoLogoId: logoPoolEntry.id,
                    palette     : logoPoolEntry.farbpalette,
                    isAILogo : false,
                    hasTackleTwill :false,
                    berechnungsFeature : "",
                    zuLoeschenBeiProduktUndDesignWechsel:0
                });
                logoObject.getOriginalSVG(true);
                break;
            case SelObTypes.STOCKLOGO:
                logoObject = new StockLogo({
                    id          : id,
                    partName    : part,
                    filename  : logoPoolEntry.filename.replace(/\.png$/, ".svg"),
                    pathToLogo  : logoPoolEntry.logoURL,
                    logoId      : null,
                    chromoLogoId: null,
                    stockLogoID : logoPoolEntry.id,
                    palette     : logoPoolEntry.farbpalette,
                    isAILogo:false,
                    hasTackleTwill :false,
                    berechnungsFeature : "",
                    zuLoeschenBeiProduktUndDesignWechsel:0
                });
                logoObject.getOriginalSVG(true);
                break;
        }
        return logoObject;
    }

    /**
     * Ein Logo soll erschaffen werden (ist aber noch nicht eingefügt. BSP: Beginn des Drag and Drop Vorgangs)
     * ist die nächste Aktion des Benutzers nicht das Einfügen des Objekts, so wird es wieder gelöscht
     * Der Z-Index wird erst bei "insertSelObById" gesetzt!!
     */
    public createLogoObject(logoPoolEntry:LogoPoolEntry):Logo|ChromoLogo {
        return LogoPoolController.createLogoObjectStatic(logoPoolEntry);
    }


    deleteLogoFromLogoPool(logoPoolEntry:LogoPoolEntry) {
        const $this = this;
        sendPostRequest("/konfigurator_php/actionmodul/deleteLogo.php", {id:logoPoolEntry.id})
            .then((response)=>{
                if (parseInt(response.data) === 1) {
                    $this.model.logoPool.removeLogo(logoPoolEntry);
                    EventVerteiler.broadcast("logoPoolItemsDeletedEvent", {deletedLogos: [logoPoolEntry]});
                } else {
                    handleError("ajaxFail", "deleteLogo", "could not delete Logo");
                }
            })
    }

    deleteStocklogoFromLogoPool(logoPoolEntry:LogoPoolEntry) {
        const $this = this;
        axios.get("/konfigurator_php/stocklogos/deleteFromLibrary.php?id="+logoPoolEntry.id).then(response=>{
            if (response.data === "success") {
                $this.model.logoPool.removeStockLogo(logoPoolEntry);
                EventVerteiler.broadcast("logoPoolItemsDeletedEvent", {deletedLogos: [logoPoolEntry]});
            } else {
                handleError("ajaxFail", "deleteLogo", "could not delete Logo");
            }
        })
    }


    deleteLogoPoolEntry(logoPoolEntry:LogoPoolEntry) {
        const $this = this;

        const doIt = function() {
            switch(logoPoolEntry.type) {
                case SelObTypes.LOGO:
                    $this.deleteLogoFromLogoPool(logoPoolEntry);
                    return;
                case SelObTypes.STOCKLOGO:
                    $this.deleteStocklogoFromLogoPool(logoPoolEntry);
            }
        }
        EventVerteiler.broadcast("displayDialogEvent", {dialog: "confirmLogoDeletion", callbacks: [doIt]});
    }

    private static isEqualInProperties(entry, properties) {
        for(const prop in properties) {
            if(entry[prop] !== properties[prop]) {
                return false;
            }
        }
        return true;
    }

    private getFirstLogoPoolEntryIndexByProperties(properties, arrayToSearch:LogoPoolEntry[]|null = null):number {
        if(arrayToSearch === null) {
            arrayToSearch = this.model.logoPool.getLogos();
        }

        for(let i=0; i< arrayToSearch.length; i++) {
            if(LogoPoolController.isEqualInProperties(arrayToSearch[i], properties)) {
                return i;
            }
        }
        return -1;

    }

    private getFirstLogoPoolEntryByProperties(properties, arrayToSearch:LogoPoolEntry[]|null= null):LogoPoolEntry|null {
        if(arrayToSearch === null) {
            arrayToSearch = this.model.logoPool.getLogos();
        }
        const index = this.getFirstLogoPoolEntryIndexByProperties(properties, arrayToSearch);
        if(index > -1) {
            return arrayToSearch[index];
        }
        return null;
    }

    public getLogoPoolEntryByTypeAndID(type, id, arrayToSearch=null):LogoPoolEntry|null {
        return this.getFirstLogoPoolEntryByProperties({type:type, id:id}, arrayToSearch);
    }
}
